/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_OutInputs */

const en_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Out`)
};

const nl_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afmelden`)
};

/**
* | output |
* | --- |
* | "Sign Out" |
*
* @param {Sign_OutInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_out = /** @type {((inputs?: Sign_OutInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_OutInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_sign_out(inputs)
	return en_sign_out(inputs)
});